export default __webpack_public_path__ + "c74428ec1f3092402cf32d7993d46d1c.svg";